<td scope="row" class="text-end">{{ warrantyRequest.warranty_id }}</td>
<td>
  @if (warrantyRequest.remarks) {
    <i class="material-icons small">
      chat_bubble_outline
    </i>
  }
  {{ warrantyRequest.remarks }}
</td>
<td>{{warrantyRequest.sent_date}}</td>
<td>
  @if (!warrantyRequest.sent_date) {
    {{'ACTIVE'|translate}}
  }
  @if (warrantyRequest.sent_date) {
    {{'PENDING'|translate}} / {{'HANDLED'|translate}}
  }
  @if (warrantyRequest.rth_number) {
    <span class="d-block">{{'REFERENCENO'|translate}}: {{warrantyRequest.rth_number}}</span>
  }
</td>
<td class="d-flex justify-content-end">
  <a [routerLink]="['/' + companyGroupCode + '/warranty/' + warrantyRequest.warranty_id]" class="btn ms-auto"
  [ngClass]="warrantyRequest.active ? 'btn-primary' : 'btn-outline-primary'">{{(warrantyRequest.active ? 'ADD' : 'VIEW')|translate}}</a>
</td>

